import React from "react";
import Dashboard from "./pages/Auth"; // Adjust the path as necessary
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Helmet } from "react-helmet-async";
import PreventZoom from "./components/PreventZoom/PreventZoom";
//import "./i18n"; 

function App() {
  return (
    <>
      <Helmet>
        <title>PATT Pro</title>
        <meta
          name="description"
          content="Welcome to the PATT PRO dashboard a full product for event and team management."
        />
        <meta property="og:title" content="PATT PRO" />
        <meta
          property="og:description"
          content="Welcome to the PATT PRO dashboard a full product for event and team management."
        />
        <meta property="og:image" content="https://example.com/my-image.jpg" />
        <meta property="og:url" content="https://example.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>{" "}
      <PreventZoom />
      <div className="App">
        <Dashboard />
      </div>
    </>
  );
}

export default App;
